import React from 'react';
import '../assets/css/modal.css';

// 팝업 용 모달
// Modal Layer Popup
const Modal = ({ children, onClose, width, height }) => {
  const modalStyle = {
    width: width || 'auto',
    height: height || 'auto',
  };

  return (
    <div className="modal-overlay">
      <div className="modal-body" style={modalStyle}>
        <button className="modal-close-btn" onClick={onClose}>✕</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
